// extracted by css-extract-rspack-plugin
export default {"ShareButton":"ShareButton-module__ShareButton__G10R53t","Text":"ShareButton-module__Text__z5yaPzC"};